import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    id: 'App.CertificationApprovals.PageTitle',
    defaultMessage: 'Certification Approvals',
  },
  header: {
    id: 'App.CertificationApprovals.Header',
    defaultMessage: 'Certification Approvals',
  },
  funnelRegionLabel: {
    id: 'App.CertificationApprovals.FunnelRegionLabel',
    defaultMessage: 'Open certifications by stage',
  },
  // Accessible name for a clickable stage row. The stage label itself comes
  // from the data, so it is interpolated rather than written here.
  stageAriaLabel: {
    id: 'App.CertificationApprovals.StageAriaLabel',
    defaultMessage:
      '{label}, {count, plural, one {# certification} other {# certifications}}',
  },
  // Shown when the stage list or the counts cannot be loaded — a clear message
  // rather than a blank screen or an endless spinner.
  loadError: {
    id: 'App.CertificationApprovals.LoadError',
    defaultMessage:
      'We couldn’t load certification approvals right now. Please try again.',
  },
  // Shown when the property genuinely has no open certs — the funnel would
  // otherwise be a row of zeros, which reads as broken rather than as good
  // news.
  emptyState: {
    id: 'App.CertificationApprovals.EmptyState',
    defaultMessage: 'This property has no open certifications.',
  },

  // --- Drill-down panel and cert cards (step 9) ---

  // Accessible name for the panel region beside the funnel. The stage label
  // comes from the data, so it is interpolated rather than written here.
  panelRegionLabel: {
    id: 'App.CertificationApprovals.PanelRegionLabel',
    defaultMessage: 'Certifications in {label}',
  },
  // The count shown under the stage name in the panel header.
  panelCount: {
    id: 'App.CertificationApprovals.PanelCount',
    defaultMessage:
      '{count, plural, one {# certification} other {# certifications}}',
  },
  // Shown when this stage's certs cannot be loaded. Scoped to the panel — the
  // funnel beside it is unaffected — so the message is about this stage, not
  // the whole screen.
  panelLoadError: {
    id: 'App.CertificationApprovals.PanelLoadError',
    defaultMessage:
      'We couldn’t load the certifications for this stage right now. Please try again.',
  },
  // Shown when a stage genuinely has no open certs — an explicit empty state,
  // not a blank list.
  panelEmptyState: {
    id: 'App.CertificationApprovals.PanelEmptyState',
    defaultMessage: 'No certifications in this stage.',
  },
  // Loads the next page of certs in place, without reloading the screen.
  panelLoadMore: {
    id: 'App.CertificationApprovals.PanelLoadMore',
    defaultMessage: 'Load more',
  },
  // Card field labels. None of these is a compliance status name; the status
  // is in the panel header, never on the card.
  cardUnitLabel: {
    id: 'App.CertificationApprovals.CardUnitLabel',
    defaultMessage: 'Unit',
  },
  cardProgramLabel: {
    id: 'App.CertificationApprovals.CardProgramLabel',
    defaultMessage: 'Program',
  },
  cardCertTypeLabel: {
    id: 'App.CertificationApprovals.CardCertTypeLabel',
    defaultMessage: 'Cert type',
  },
  cardEffectiveDateLabel: {
    id: 'App.CertificationApprovals.CardEffectiveDateLabel',
    defaultMessage: 'Effective date',
  },
  cardInStatusLabel: {
    id: 'App.CertificationApprovals.CardInStatusLabel',
    defaultMessage: 'In this status',
  },
  cardCorrectionRoundsLabel: {
    id: 'App.CertificationApprovals.CardCorrectionRoundsLabel',
    defaultMessage: 'Correction rounds',
  },
  // "Was" — the status a held cert held before the hold. Its value comes from
  // the history data, not from any string typed here.
  cardWasLabel: {
    id: 'App.CertificationApprovals.CardWasLabel',
    defaultMessage: 'Was',
  },
  // Relative time in the current status. Zero is a real, useful value: "Today".
  cardDaysInStatus: {
    id: 'App.CertificationApprovals.CardDaysInStatus',
    defaultMessage: '{days, plural, =0 {Today} one {# day} other {# days}}',
  },
  // Who moved the cert into this status. Accountability, kept quiet.
  cardMovedBy: {
    id: 'App.CertificationApprovals.CardMovedBy',
    defaultMessage: 'by {name}',
  },
});

export default messages;
